import _styled from "styled-components";
import { AnimatePresence, m } from "framer-motion";
import { Icon } from "~/features/ui/icon";
import Loading from "~/public/icons/loading.svg";
type Props = {
  show: boolean;
};
export function DeepDiveGallerySpinner(props: Props) {
  const {
    show
  } = props;
  return <AnimatePresence>
      {show && <_StyledMDiv>
          <Icon icon={Loading} />
        </_StyledMDiv>}
    </AnimatePresence>;
}
var _StyledMDiv = /*#__PURE__*/_styled(m.div).withConfig({
  displayName: "deep-dive-gallery-spinner___StyledMDiv",
  componentId: "sc-s1az8k-0"
})({
  "position": "absolute",
  "inset": "0",
  "zIndex": "10",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "center"
});